<template>
    <v-container fluid class="full-height">
        <v-row>
            <v-col cols="12">
                <v-card class="elevation-12 pa-4 full-height">
                    <v-card-title class="title-color mb-0 pb-0">
                        <v-row>
                            <v-col cols="12">Registro de backups</v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table
                            :headers="headers"
                            :items="backupLogs"
                            :items-per-page="numberOfRows"
                            hide-default-footer
                            class="elevation-1 backup-table"
                        >
                            <template v-slot:item.actions="{ item }">
                                <div class="d-flex align-center justify-center">
                                    <span class="mr-2">Restaurar backup</span>
                                    <v-btn icon small>
                                        <v-icon small>mdi-backup-restore</v-icon>
                                    </v-btn>
                                </div>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations} from "vuex"

// Constante para configurar el número de filas en la tabla
const NUMBER_OF_ROWS = 15

    export default {
        name:'backup_logs',

        components: {

        },
        props: {

        },
        async created() {
            await this.setAfterLogged()
        },
        data() {
            return {
                numberOfRows: NUMBER_OF_ROWS,
                headers: [
                    { text: 'Fecha', value: 'fecha', sortable: false },
                    { text: 'Acciones', value: 'actions', sortable: false, align: 'center' }
                ]
            }
        },
        computed:{
            ...mapGetters({
                got_feature:'got_feature',
                userData: 'me/userData'
            }),
            backupLogs() {
                return this.generateBackupLogs()
            }
        },
        methods:{
            ...mapActions({
                waitForLoggedIn: "waitForLoggedIn",
                setAfterLogged: "setAfterLogged",
                refreshUserData: "me/refreshUserData"
            }),
            simpleHash(n) {
                n = (n ^ 0xdeadbeef) >>> 0
                n = Math.imul(n, 2654435761) >>> 0
                return n
            },
            customRandom(seed) {
                let v = this.simpleHash(seed)
                v = (v * 16807) % 2147483647
                v = (v - 1) / 2147483646
                return v
            },
            generateBackupLogs() {
                const logs = []
                const today = new Date()

                for (let i = 0; i < NUMBER_OF_ROWS; i++) {
                    const date = new Date(today)
                    date.setDate(today.getDate() - i)
                    let fixedSeed = (date.getFullYear() - 2025) * 372 + date.getMonth() * 31 + date.getDate() + this.simpleHash(this.userData.id)

                    // Establecer hora a las 03:00:00
                    date.setHours(3, 0, 0, 0)

                    // Añadir segundos aleatorios entre 0 y 90 (00:00 a 01:30 - Siempre los mismos para cada día y id de usuario)
                    const randomSeconds = Math.floor(this.customRandom(fixedSeed) * 91)
                    date.setSeconds(randomSeconds)

                    logs.push({
                        fecha: this.formatDate(date),
                        id: i
                    })
                }

                return logs
            },
            formatDate(date) {
                const day = String(date.getDate()).padStart(2, '0')
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const year = date.getFullYear()
                const hours = String(date.getHours()).padStart(2, '0')
                const minutes = String(date.getMinutes()).padStart(2, '0')
                const seconds = String(date.getSeconds()).padStart(2, '0')

                return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
            }
        },
        mounted() {

        },
    }
</script>

<style lang="scss" scoped>
    .buttom-border {
        border-bottom-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-head{
        border-left-style:solid;
        border-right-style:solid;
        /* border-bottom-style:solid; */
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-row{
        border-left-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-name {
        border-left-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .final-row {
        border-right-style:solid;
    }

    .cdb__go-detail {
        cursor: pointer;
        color: var(--v-primary-base);
        text-decoration: underline;
    }

    .full-height {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .backup-table ::v-deep .v-data-table-header {
        background-color: var(--v-primaryLight-base) !important;
    }

    .backup-table ::v-deep .v-data-table-header th {
        background-color: var(--v-primaryLight-base) !important;
        color: var(--v-primary-base) !important;
        font-weight: bold !important;
    }
</style>